import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { reloadIfBuildStale } from '../services/staleBuildReload';

// The moment a newly deployed build is free to take: the user asked for another page, so this
// one is being torn down whichever way it is rendered. Sits inside the router but above every
// provider, so it covers the login screen and the popped-out chat window too.
//
// Rendered as a component rather than folded into AppContent so the trigger stays independent
// of what any route decides to render.
const StaleBuildReloader: React.FC = () => {
  const { pathname } = useLocation();

  // Runs on first mount as well, which is a no-op unless the version poll already reported a
  // mismatch before React finished mounting — in which case reloading before the user has
  // touched anything is the cheapest moment there is.
  useEffect(() => {
    reloadIfBuildStale();
  }, [pathname]);

  return null;
};

export default StaleBuildReloader;
